import React from "react";
import SearchModeToggle, {
  SEARCH_MODE_KEYS,
  SEARCH_MODES,
} from "./SearchModeToggle";

let inputRef = React.createRef();

const SearchBox = ({
  handleSearch,
  handleSearchSubmit,
  searchPlaceHolder,
  withBackground,
  isDirectory,
  width = 300,
  Ecommerce,
  isMobile = false, // unused, kept to avoid leaking into ...props DOM spread
  shouldShowSearchModeToggle = false,
  searchMode = SEARCH_MODE_KEYS.maia,
  onSearchModeChange = () => {},
  handleAiSearchSubmit,
  ...props
}) => {
  const modeConfig = SEARCH_MODES[searchMode];

  const submitSearch = (e) => {
    if (
      shouldShowSearchModeToggle &&
      searchMode === SEARCH_MODE_KEYS.maia &&
      handleAiSearchSubmit
    ) {
      e.preventDefault();
      handleAiSearchSubmit(inputRef.current?.value || "", e);
      inputRef.current?.blur();
      return;
    }

    handleSearchSubmit(e);
    inputRef.current?.blur();
  };

  if (shouldShowSearchModeToggle) {
    return (
      <form
        noValidate
        onSubmit={submitSearch}
        className={`flex items-center gap-2 rounded-full p-[5px] ${
          withBackground ? "bg-base-90" : "bg-white"
        }`}
      >
        <div className="[&>div]:w-[120px] [&_button]:text-[12px] [&_button]:leading-[18px]">
          <SearchModeToggle
            mode={searchMode}
            onModeChange={onSearchModeChange}
            className=""
          />
        </div>
        <input
          ref={inputRef}
          style={{ width }}
          className="box-border h-9 w-[225px] min-w-0 border-none bg-transparent p-2 font-default text-[14px] text-sm font-light leading-5 text-black outline-none placeholder:text-center placeholder:tracking-[0.2px] placeholder:text-base-25 focus:border-none focus:caret-secondary focus:outline-none"
          type="text"
          placeholder={
            searchPlaceHolder ? searchPlaceHolder : modeConfig.placeholder
          }
          onChange={handleSearch}
          {...props}
          data-cy="search-input"
        />
        <button
          type="submit"
          className={`flex aspect-square h-[34px] w-[34px] shrink-0 cursor-pointer items-center justify-center rounded-full border-0 p-0 ${
            inputRef.current?.value.trim() ? "bg-[#007983]" : "bg-[#DEE0E2]"
          }`}
          aria-label="Submit search"
        >
          <i
            data-cy="search-icon"
            className={`${modeConfig.icon} text-base text-white`}
            aria-hidden="true"
          />
        </button>
      </form>
    );
  }

  return (
    <form noValidate onSubmit={submitSearch} className="relative">
      <input
        ref={inputRef}
        style={{ width }}
        className={`${
          withBackground || isDirectory
            ? "placeholder:text-base-25"
            : "border-white placeholder:text-white focus:border-b"
        } box-border h-9 rounded-[50px] border-0 bg-base-90 px-8 py-2 font-default text-sm font-light leading-5 text-black outline-0 placeholder:tracking-[0.2px] focus:rounded-[50px] focus:border-0 focus:caret-secondary focus:outline-0 focus:[background-position:100%_center] custom-lg:h-11 `}
        type="text"
        placeholder={"Search All myApplied"}
        onChange={handleSearch}
        {...props}
        data-cy="search-input"
      />
      <i
        data-cy="search-icon"
        className={`${
          withBackground || isDirectory ? "text-[#a3a9ac]" : "text-white"
        } fal fa-search absolute right-4 top-[7px] cursor-pointer text-base custom-lg:right-6 custom-lg:top-[10px] custom-lg:text-[18px]`}
        onClick={handleSearchSubmit}
      />
    </form>
  );
};

export default SearchBox;
